'use strict';

var angular = require('angular');
var _ = require('lodash');

require('../libs/angular-1.6.4/angular-sanitize.min');
require('../libs/jquery-cookie/jquery-cookie');
require('../libs/jquery-ui.autocomplete.match/jquery-ui.autocomplete.match');

// modules
require('./modules/_app');

// factories
require('./factories/_jquery');
require('./factories/_searchService');
require('./factories/_pageSearchService');
require('./factories/_eventSearchService');
require('./factories/_authorsSearchService');

// directives
require('./directives/_pageSearch');
require('./directives/_searchPagination');
require('./directives/_externalSearch');
require('./directives/_bgImageSrcSet');
require('./directives/_formCustom');
require('./directives/_eventsList');
require('./directives/_authorsList');
require('./directives/_videoModal');

// directives - Angular templates
require('./templates/dictionaryEntry/_dictionaryEntry');
require('./templates/mediaGallery/_mediaGallery');



// validators


// directives - partials
require('../../../Views/Blocks/HomeHeroBlock/_heroGradient');
require('../../../Views/Blocks/ImageSliderBlock/_slider');
require('../../../Views/Blocks/ImageGridBlock/_componentImageGallery');
require('../../../Views/Blocks/JourneyHeroBlock/_dotsNav');
require('../../../Views/Blocks/SimpleTextBlock/_simpleTextBlock');
require('../../../Views/Blocks/LeadershipContainerBlock/_componentPeopleSlider');
require('../../../Views/Shared/Partials/JourneyHeader/_journeyNav');
require('../../../Views/Shared/Partials/SiteHeader/_navigationTakeover');
require('../../../Views/Shared/Partials/SiteHeader/_searchPop');

// directives - partials - modals

// directives - blocks

// directives - pages

// directives - nodes

// todo: Look at _LayoutScriptsHead.cshtml and _LayoutScriptsBody.cshtml - make sure we don't have any overlap
require('../libs/bootstrap/javascripts/bootstrap.min');
require('../libs/jquery/jquery-3.5.1.min');
require('./utilities/_matchHeight');



$(document).ready(function () {

	//update live chat button and change if offline
	$('.live-chat-sticky').click(function(e) {
		$('.LPMcontainer').trigger('click');
	});


	var dfd = $.Deferred();
	var checkChatOffline = setInterval(function () {
		if ($(".LPMimage").length) {
			dfd.resolve();
			clearInterval(checkChatOffline);
		}
	}, 1000);

	dfd.done(function () {
		var offline = $('.LPMimage').attr("src").indexOf('repoffline') !== -1;
		if (offline) {
			$(".live-chat-sticky.offline").show('slide');
			$(".live-chat-sticky.online").hide();
		} else {
			$(".live-chat-sticky.offline").hide();
			$(".live-chat-sticky.online").show();
		}
		
	});
	
});

$(window).on('load', function () {
	var options = {
		byRow: true,
		property: 'height',
		target: null,
		remove: false
	};

	var $equalizeColumnContainers = $("[data-column-equalizer]");

	$equalizeColumnContainers.each(function () {
		var $this = $(this);
		var $items = $this.children('[data-equalizer-watch]');
		$items.matchHeight(options);
	});
});

jQuery.ui.autocomplete.prototype._resizeMenu = function () {
    var ul = this.menu.element;
    ul.outerWidth(this.element.outerWidth());
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this === null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return -1.
            return -1;
        },
        configurable: true,
        writable: true
    });
}

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (search, pos) {
        return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    };
}







//////////////////
// WEBPACK FOOTER
// ./static/common/js/common.js
// module id = 1
// module chunks = 0